import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import lodash from 'lodash';
import { AppContext } from 'commons-ui';
import useService from '../../utils/useService';
import { hydrateFormData, dehydrateFormData } from '../../utils/formDataParser';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestUpdateSchema } = useService();

	const updateMttSchema = (updatedData: any) => {
		setShowLoader(true);

		requestUpdateSchema(app.appName, updatedData).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.externalMessage || 'Error occured while updating the mtt schema', { type: 'error' });
					setShowLoader(false);
				} else {
					showAlert('Record updated');
					setShowLoader(false);
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		updateMttSchema(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: hydrateFormData(lodash.get(location, ['state', 'rowData'])),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
